import { Component, HostBinding, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "angular-2-local-storage";
import { BehaviorSubject } from "rxjs";
import { environment } from "../../../../environments/environment";
import { PolicyService } from "../../../service/policy.service";
import { AuthorizedApps } from "../../../enum/shared/authorized-apps.enum";

@Component({
    selector: "bo-builk-sidebar",
    templateUrl: "./builk-sidebar.component.html",
    styleUrls: ["./builk-sidebar.component.scss"]
})

export class BuilkSidebarComponent implements OnInit {

    isCultureAccess: boolean = false;

    generalUrl: Array<string> = [
      "profunnel",
      "poitem",
      "usermanager",
      "customcostcode",
      "mybuilk"
    ];

    // initialize a private variable _data, it's a BehaviorSubject
    private _data = new BehaviorSubject<boolean>(false);

    @Input()
    set toggle(value) {
        // set the latest value for _data BehaviorSubject
        this._data.next(value);
    }
    get toggle(): boolean {
        // get the latest value from _data BehaviorSubject
        return this._data.getValue();
    }

    sidebar: string = "sidebar";
    iconNav: string = "icon-nav";

    constructor(
        public router: Router,
        private readonly localStorageService: LocalStorageService,
        private readonly policyService: PolicyService,
    ) { }

    ngOnInit(): void {
        this._data
            .subscribe(x => {
                this.toggleSidebar(this.toggle);
            });
        this.getCulture();
    }

    toggleSidebar(isToggle: boolean): void {
        // sidebar
        if (isToggle){
            this.sidebar = "toggle-sidebar";
        } else {
            this.sidebar = "sidebar";
        }

        // toggle-icon-nav
        if (isToggle) {
            this.iconNav = "toggle-icon-nav";
        } else {
            this.iconNav = "icon-nav";
        }
    }

    getCurrentUrl() {
      let currentRoute = this.router.url;
      let routeSegments = currentRoute.split('/');
      let secondSegment = routeSegments[2];
      if (!this.generalUrl.includes(secondSegment)) {
        this.navigateTo();
      }
    }

    getCulture() {
      this.policyService.getUserPolicy(environment.firebaseConfig.policyCollection,"userEmail", this.localStorageService.get<string>("userEmail")).subscribe(response => {
        if (response.length > 0) {
          const authorizedApp = response[0].authorizedApps.find(f => f.appName === AuthorizedApps.Builk);
          if (authorizedApp !== undefined) {
            if (this.localStorageService.get<string>("userEmail") == "patai@builk.com") {
              // by pass if exist this email.
              this.isCultureAccess = true;
            } else {
              let country = authorizedApp.country;
              if (country.length > 0) {
                if (country.some(val => val.toLocaleLowerCase() == 'th')) {
                  this.isCultureAccess = true;
                } else {
                  this.getCurrentUrl();
                }
              } else {
                this.getCurrentUrl();
              }
            }

          } else {
            this.getCurrentUrl();
          }
        }
      });
    }

    navigateTo() {
      this.router.navigate(['/builk/profunnel']);
    }
}
